import { ICON } from 'shared/AIcon/enums'
import { HEADER_ITEM_ID } from '@/components/AHeader/enums'
import { FONT } from 'shared/ACharWidth/enums'

export const HEADER_MENU_ITEM_MORE = {
  // (!) Make sure to update HEADER_ITEM_WIDTH_BY_ID if the name is updated
  Name: 'More',
  Link: null,
  Icon: ICON.BURGER_MENU,
  ChildItems: [],
  Id: HEADER_ITEM_ID.MORE,
  CustomFont: FONT.INTER_14_BOLD,
  HideArrow: true
}
